import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LossOrScrapSourceEnum } from 'src/app/shared/enums/loss-or-scrap-source.enum';

@Component({
    selector: 'app-modal-select-origin',
    template: `
        <div class="flex flex-col items-center p-6">
            <div class="flex justify-center gap-4">
                <button (click)="selectOrigin(LossSourceEnum.RAW_MATERIAL)"
                    class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6">
                    Materia Prima
                </button>
                <button (click)="selectOrigin(LossSourceEnum.FINAL_PRODUCT)"
                    class="text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-green-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6">
                    Producto Final
                </button>
            </div>
        </div>
    `
})
export class ModalSelectOriginComponent {
    @Output() originSelected = new EventEmitter<LossOrScrapSourceEnum>();
    LossSourceEnum = LossOrScrapSourceEnum;
    selectOrigin(origin: LossOrScrapSourceEnum) {
        this.originSelected.emit(origin);
    }
}
